/* ------------------------------------------------------------------
   CREAM taste-match dupe card — search results page + predictive drawer.

   Loaded once on initial page load and uses EVENT DELEGATION on document. The
   predictive drawer replaces its results via AJAX innerHTML on every keystroke, so
   directly-bound handlers would be lost and inline scripts wouldn't run. A single
   delegated listener is deliberately preferred over a Web Component here: the card
   would otherwise connect/disconnect on every keystroke re-render.

   Mirrors the VELO PDP hero's quick-add flow (add.js with bundled sections -> cart.js
   -> publish cartUpdate -> open cart drawer) and emits a 'tso:search_to_cream'
   analytics event to whichever Google channel is live.
   ------------------------------------------------------------------ */
(function () {
  if (window.__tsoCreamDupeInit) return;
  window.__tsoCreamDupeInit = true;

  /** @returns {string} Localised cart root, e.g. "/" or "/en-eu/". */
  const cartRoot = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /**
   * Emit one conversion event to every Google channel this store might use — each
   * call guarded so it's a no-op where absent (Shopify Custom Pixel / GTM / gtag).
   * The GA4 event name has no colon; only the Shopify namespace form does.
   * @param {HTMLElement} host - the [data-tso-search-dupe] element
   * @param {string} action - 'card_click' | 'quick_add'
   */
  const track = (host, action) => {
    if (!host) return;
    const payload = {
      action,
      source_product: host.dataset.sourceHandle || '',
      source_product_id: host.dataset.sourceId || '',
      target_product: host.dataset.targetHandle || '',
      target_product_id: host.dataset.targetId || '',
      target_variant_id: host.dataset.targetVariant || '',
      value: (parseInt(host.dataset.targetPriceCents, 10) || 0) / 100,
      currency: host.dataset.currency || '',
      surface: 'search',
    };
    try { if (window.Shopify?.analytics?.publish) Shopify.analytics.publish('tso:search_to_cream', payload); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'tso_search_to_cream', ...payload }); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'tso_search_to_cream', payload); } catch (e) {}
  };

  /**
   * Add the CREAM variant like a native add so the header badge + cart drawer refresh.
   * Bundled-sections mirrors the theme's own product-form flow.
   * @param {HTMLElement} btn - the clicked .nik-upsell__cart element
   */
  const quickAdd = async (btn) => {
    const id = btn.dataset.addId;
    if (!id || btn.classList.contains('is-loading')) return;
    const host = btn.closest('[data-tso-search-dupe]');
    btn.classList.add('is-loading');

    const sections = [];
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    } catch (e) {}

    const body = new FormData();
    body.append('id', id);
    body.append('quantity', '1');
    body.append('sections', sections.join(','));
    body.append('sections_url', window.location.pathname);

    try {
      const addResponse = await fetch(new URL(`${cartRoot()}cart/add.js`, window.location.origin), {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body,
      });
      const state = await addResponse.json();
      if (state.status) throw new Error(state.description || 'Add to cart failed');

      const cartResponse = await fetch(new URL(`${cartRoot()}cart.js`, window.location.origin), { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      cart.sections = state.sections;

      try {
        if (window.theme?.pubsub?.PUB_SUB_EVENTS) {
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'tso-search-dupe', productVariantId: id, cart });
        }
      } catch (e) {}

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') { try { drawer.show(btn); } catch (e) {} }

      btn.classList.add('is-added');
      track(host, 'quick_add');
      setTimeout(() => btn.classList.remove('is-added'), 1800);
    } catch (error) {
      console.error('[tso search dupe]', error);
    } finally {
      btn.classList.remove('is-loading');
    }
  };

  // Capture phase so the click is handled before the predictive-search form submits
  // (the card lives inside the search <form>).
  document.addEventListener('click', (event) => {
    const cartBtn = event.target.closest?.('[data-tso-search-dupe] .nik-upsell__cart');
    if (cartBtn) {
      event.preventDefault();
      event.stopPropagation();
      quickAdd(cartBtn);
      return;
    }
    const mainLink = event.target.closest?.('[data-tso-search-dupe] .nik-upsell__main');
    if (mainLink) track(mainLink.closest('[data-tso-search-dupe]'), 'card_click'); // let navigation proceed
  }, true);
})();
